import ServerApiService from '~/libs/server/util/apiService';
import {
  DEFAULT_ARTICLES,
  LOCATION_SPECIFIC_ARTICLES,
  PageCardView,
} from '~/pages/couples/explore/components/ExpertAdvice/ExpertAdvice';
import type { VendorSearchRequest } from '~/pages/couples/explore/components/SearchResults/types/types';
import type { PostType, TopicType } from '~/types/vendorResources';
import ApiService, { ClientApiServiceType } from '~/util/apiService';

import type { ServerApiServiceType } from '../server/util/apiService';

export const getExpertAdviceArticlesForVendorSearch = async (
  vendorSearch: VendorSearchRequest,
  apiService: ServerApiServiceType | ClientApiServiceType
): Promise<PageCardView[]> => {
  const { selectedLocation } = vendorSearch;
  let slugs = DEFAULT_ARTICLES;

  if (selectedLocation?.slug && LOCATION_SPECIFIC_ARTICLES[selectedLocation.slug]) {
    slugs = [...LOCATION_SPECIFIC_ARTICLES[selectedLocation.slug], ...slugs];
  }
  return getExpertAdviceArticles(slugs, apiService);
};

export const getExpertAdviceArticles = (
  slugs: string[],
  apiService: ServerApiServiceType | ClientApiServiceType = ServerApiService
) => {
  return apiService
    .post<PageCardView[]>(`/web-marketplace-api/v1/content-api/pages/by-slug`, {
      slugs,
    })
    .catch(() => {
      return [];
    });
};

export const getTopicPage = (
  slug: string,
  contentSpace: 'vendor-hub' | 'expert-advice' = 'vendor-hub',
  apiService: ServerApiServiceType | ClientApiServiceType = ApiService
) =>
  apiService
    .get<TopicType>(`/web-marketplace-api/v2/content/${contentSpace}/topic/${slug}`)
    .catch(null);

export const getArticle = (
  slug: string,
  contentSpace: 'vendor-hub' | 'expert-advice' = 'vendor-hub',
  apiService: ServerApiServiceType | ClientApiServiceType = ApiService
) =>
  apiService
    .get<PostType>(`/web-marketplace-api/v2/content/${contentSpace}/article/${slug}`)
    .catch(null);
